import { Page } from '@/contexts/FlowNotesProvider'
import { useHall } from '@/contexts/HallProvider'
import { useAblyTypedPubSub } from '../use-ably'
import { useAxios } from '@/contexts/AxiosProvider'

interface UseFlowNotesPubSubProps {
  pages: Page[]
  setPages: React.Dispatch<React.SetStateAction<Page[]>>
}

export const useFlowNotesPubSub = ({ pages, setPages }: UseFlowNotesPubSubProps) => {
  const { hall } = useHall()
  const axios = useAxios()

  const { publish } = useAblyTypedPubSub<Page[]>(
    'flow-notes',
    ({ data }) => {
      // @ts-ignore
      if (data?.content) setPages(JSON.parse(data.content))
      else setPages(data)
    },
    hall?.id
      ? {
          url: `/flowNotes/${hall.id}`,
        }
      : undefined,
  )

  const publishFlowNotes = (newPages: Page[]) => {
    publish(newPages)
    void axios.patch(`/flowNotes/${hall.id}`, {
      content: JSON.stringify(newPages),
    })
  }

  return {
    publishFlowNotes,
  }
}
